import React, { FC } from 'react';
import { Box, Typography, TypographyProps } from '@material-ui/core';

const Section: FC<TypographyProps> = (props) => {
  return (
    <Box color='#637381' clone>
      <Typography {...props} />
    </Box>
  );
};

export default Section;
